/**
 * @fileoverview gRPC-Web generated client stub for reconpb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v0.0.0
// source: reconpb/positionrecon.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_type_date_pb = require('../google/type/date_pb.js')
const proto = {};
proto.reconpb = require('./positionrecon_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.reconpb.PositionReconServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.reconpb.PositionReconServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reconpb.ListPositionReconRequest,
 *   !proto.reconpb.ListPositionReconResponse>}
 */
const methodDescriptor_PositionReconService_ListPositionRecon = new grpc.web.MethodDescriptor(
  '/reconpb.PositionReconService/ListPositionRecon',
  grpc.web.MethodType.UNARY,
  proto.reconpb.ListPositionReconRequest,
  proto.reconpb.ListPositionReconResponse,
  /**
   * @param {!proto.reconpb.ListPositionReconRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reconpb.ListPositionReconResponse.deserializeBinary
);


/**
 * @param {!proto.reconpb.ListPositionReconRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.reconpb.ListPositionReconResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reconpb.ListPositionReconResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reconpb.PositionReconServiceClient.prototype.listPositionRecon =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reconpb.PositionReconService/ListPositionRecon',
      request,
      metadata || {},
      methodDescriptor_PositionReconService_ListPositionRecon,
      callback);
};


/**
 * @param {!proto.reconpb.ListPositionReconRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reconpb.ListPositionReconResponse>}
 *     Promise that resolves to the response
 */
proto.reconpb.PositionReconServicePromiseClient.prototype.listPositionRecon =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reconpb.PositionReconService/ListPositionRecon',
      request,
      metadata || {},
      methodDescriptor_PositionReconService_ListPositionRecon);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reconpb.ListPositionReconDetailRequest,
 *   !proto.reconpb.ListPositionReconDetailResponse>}
 */
const methodDescriptor_PositionReconService_ListPositionReconDetail = new grpc.web.MethodDescriptor(
  '/reconpb.PositionReconService/ListPositionReconDetail',
  grpc.web.MethodType.UNARY,
  proto.reconpb.ListPositionReconDetailRequest,
  proto.reconpb.ListPositionReconDetailResponse,
  /**
   * @param {!proto.reconpb.ListPositionReconDetailRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reconpb.ListPositionReconDetailResponse.deserializeBinary
);


/**
 * @param {!proto.reconpb.ListPositionReconDetailRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.reconpb.ListPositionReconDetailResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reconpb.ListPositionReconDetailResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reconpb.PositionReconServiceClient.prototype.listPositionReconDetail =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reconpb.PositionReconService/ListPositionReconDetail',
      request,
      metadata || {},
      methodDescriptor_PositionReconService_ListPositionReconDetail,
      callback);
};


/**
 * @param {!proto.reconpb.ListPositionReconDetailRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reconpb.ListPositionReconDetailResponse>}
 *     Promise that resolves to the response
 */
proto.reconpb.PositionReconServicePromiseClient.prototype.listPositionReconDetail =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reconpb.PositionReconService/ListPositionReconDetail',
      request,
      metadata || {},
      methodDescriptor_PositionReconService_ListPositionReconDetail);
};


module.exports = proto.reconpb;

